import React from "react";

import s from "./ui.module.scss";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  name?: string;
  id?: string;
  disabled?: boolean;
}

const Switch = ({ checked, onChange, label, name, id, disabled }: SwitchProps) => (
  <label className={s.switch}>
    <input
      type="checkbox"
      className={s.switchInput}
      checked={checked}
      name={name}
      id={id}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span className={s.switchTrack}>
      <span className={s.switchThumb} />
    </span>
    {label && <span className={s.switchLabel}>{label}</span>}
  </label>
);

export default Switch;
